import {createAction, props} from '@ngrx/store';
import {NotificationFormData, NotificationFormParams} from "../../services/my-settings.common.service";

export const loadFormData = createAction('[MySettings] load form data');

export const loadFormDataSuccess = createAction(
  '[MySettings] load form data success',
  props<{ formData: NotificationFormData }>()
);

export const loadFormDataFailure = createAction(
  '[MySettings] load form data failure'
);

export const updateFormData = createAction(
  '[MySettings] update form data',
  props<{
    payload: NotificationFormParams
    successFnc: () => void,
    failureFnc: () => void
  }>()
);

export const updateFormDataSuccess = createAction(
  '[MySettings] update form data success',
  props<{
    formData: NotificationFormData
  }>()
);

export const updateFormDataFailure = createAction('[MySettings] update form data failure');
